import * as React from 'react';
import * as intl from 'react-intl-universal';
import Affix from 'common/components/Affix';
import Feedback from 'common/components/Feedback';
import { post } from 'pc-sales/utils/http';
import { message } from 'antd';

/**
 * 固钉配置组件
 */
export default class AffixConfig extends React.Component<any> {
    /**
     * 意见反馈提交
     * @param values
     * @returns {Promise<void>}
     */
    feedbackHandler = (values: any) => post('/v2/platform/proposal', values).then(() => {
        message.success(intl.get('Hint.SubmitSuccess'));
    }).catch(err => console.log(err));

    /**
     * 获取旧系统内容
     * @returns {JSX.Element}
     */
    getContent = (link: any) => (
        <a target="_blank" href={link}>
            <img src={window.config.img_file(`/images/icons/computer.png`)} alt='computer'/>
        </a>
    );

    render() {
        let options: any[] = [{
            key: 'feedback',
            title: intl.get('Action.Feedback'),
            custom: ({ className }: any) => <Feedback className={className} onSubmit={this.feedbackHandler}/>
        }];
        if (this.props.oldLink) {
            options.push({
                key: 'openOldLink',
                title: intl.get('Action.OpenOldLink'),
                custom: this.getContent(this.props.oldLink)
            });
        }
        return (
            <Affix options={options}/>
        );
    }
}
